import { IProjectResourceItem } from '../../interfaces/iproject-resource-item';
import { CostCodeCostType } from '../cost-code-cost-type';
import { Item } from '../item';
import { ItemCategory } from '../item-category';
import { Project } from '../project';
import { ProjectEstimateStatus } from '../project-estimate-status';
import { UnitOfMeasure } from '../unit-of-measure';

export class ProjectResourceItemBase {
  ProjectResourceItemId: number;
  ProjectId: number;
  ItemCategoryId: number | null;
  ResourceCalculationId: number;
  ResourceCalculationValue: string | null;
  ItemNumber: number | null;
  ItemDescription: string | null;
  EstimateDate: Date | null;
  ExtendedValue: number;
  Rate: number;
  Quantity: number;
  CostCodeCostTypeId: number | null;
  EstimateVersion: number | null;
  IsSynced: boolean | null;
  ProjectEstimateStatusId: number | null;
  LastUpdatedUser: string | null;
  LastUpdatedDate: Date | null;
  UnitOfMeasureId: number | null;
  ItemId: number | null;
  IsManualAdd: boolean | null;
  ProjectResourceItemTypeId: number | null;
  Phase: string | null;
  Step: string | null;
  NeedByDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CostCodeCostType?: CostCodeCostType;
  ItemCategory?: ItemCategory;
  Item?: Item;
  ProjectEstimateStatus?: ProjectEstimateStatus;
  Project?: Project;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IProjectResourceItem) {
    if (item) {

      this.ProjectResourceItemId = item.ProjectResourceItemId;
      this.ProjectId = item.ProjectId;
      this.ItemCategoryId = item.ItemCategoryId;
      this.ResourceCalculationId = item.ResourceCalculationId;
      this.ResourceCalculationValue = item.ResourceCalculationValue;
      this.ItemNumber = item.ItemNumber;
      this.ItemDescription = item.ItemDescription;
      this.EstimateDate = item.EstimateDate ? new Date(item.EstimateDate) : null;
      this.ExtendedValue = item.ExtendedValue;
      this.Rate = item.Rate;
      this.Quantity = item.Quantity;
      this.CostCodeCostTypeId = item.CostCodeCostTypeId;
      this.EstimateVersion = item.EstimateVersion;
      this.IsSynced = item.IsSynced;
      this.ProjectEstimateStatusId = item.ProjectEstimateStatusId;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.ItemId = item.ItemId;
      this.IsManualAdd = item.IsManualAdd;
      this.ProjectResourceItemTypeId = item.ProjectResourceItemTypeId;
      this.Phase = item.Phase;
      this.Step = item.Step;
      this.NeedByDate = item.NeedByDate ? new Date(item.NeedByDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CostCodeCostType = new CostCodeCostType(item.CostCodeCostType);
      this.ItemCategory = new ItemCategory(item.ItemCategory);
      this.Item = new Item(item.Item);
      this.ProjectEstimateStatus = new ProjectEstimateStatus(item.ProjectEstimateStatus);
      this.Project = new Project(item.Project);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}